import { Box } from '@factorialco/deprecated-design-system'

import { CardStatusTag } from 'modules/banking/components/CardStatusTag'
import { BankingCard } from 'modules/banking/lib/cards/types'

export const Status: React.FC<{ card: BankingCard }> = ({ card }) => {
  return (
    <Box flexDirection="row" alignItems="center" gap="s8">
      <CardStatusTag card={card} showCircle={false} />
    </Box>
  )
}
